import { Button, Modal } from 'antd';
import React from 'react';

import { isDeactivated } from '@client/utils/form.util';
import { getTranslatedMessage } from '@client/utils/i18n.util';

import styles from '../components.module.less';

import type { TDeleteWarning } from '@client/types/notification.type';
import type { HookAPI } from 'antd/es/modal/useModal';

type TConfig = {
  modalApi: HookAPI;
};

/**
 * Displays a modal warning the user about deleting an entity.
 * @param {TDeleteWarning} props The props for the component.
 * @param {string} props.translateKey The name of the entity to delete.
 * @param {object} props.styles The style of the modal.
 * @param {string} props.title The title of the modal.
 * @param {string} props.content The content of the modal.
 * @param {() => void} props.onApprove The function to call when the user confirms the deletion.
 */
export const deleteWarning = (props: TDeleteWarning): void => {
  const t = getTranslatedMessage;

  const { config, translateKey, status, onApprove } = props;

  const title =
    props.title ||
    (isDeactivated(status)
      ? t('message.delete.warning', translateKey)
      : t('message.deactivate.warning', translateKey));

  const content =
    props.content ||
    (isDeactivated(status)
      ? t('message.delete.confirm', translateKey)
      : t('message.inactive.confirm', translateKey));

  const { modalApi } = config as TConfig;

  modalApi.warning({
    title,
    content,
    className: 'modalApi',
    centered: true,
    footer: (
      <div className={styles.modalFooter}>
        <Button key={'back'} onClick={Modal.destroyAll}>
          {t('actions.cancel')}
        </Button>
        <Button
          key={'confirm'}
          type={'primary'}
          danger
          onClick={(e) => {
            e.preventDefault();

            Modal.destroyAll();
            onApprove?.();
          }}
        >
          {t('actions.confirm')}
        </Button>
      </div>
    ) as React.ReactNode,
  });
};
